import { formatMoney as format } from '@breeze-platform-ui/money/esm/utils';

const phMoneyProps = {
  currency: 'PHP',
  symbolPosition: 'prefix',
  digitGroupingSeparator: ',',
  decimalSeparator: '.',
} as const;

export const formatMoney = (value: number | string) => {
  const { numerals, smalls, currency } = format({
    value,
    precision: 2,
    showSmalls: true,
    trimZeros: true,
    showCurrencyWithNull: true,
    ...phMoneyProps,
  });

  const wholePart = numerals.reduce((str, numeral, index) => {
    const delimiter = index ? ',' : '';
    return `${str}${delimiter}${numeral}`;
  }, '');

  return `${currency}${wholePart}${smalls}`;
};
